export default __webpack_public_path__ + "static/media/Flower Petals.4666c6bb.png";